import { base_colorAction, text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_slow } from 'ext-ui/style/transitionSpeeds'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: ${spacing(1)} 0;
    gap: ${spacing(2)};

    &:focus-visible {
      outline: 2px solid ${base_colorAction};
      outline-offset: 2px;
      border-radius: 4px;
    }
  }

  .accordion-title {
    ${font_md};
    font-family: ${font_family_weight_medium};
    color: ${text_colorTextSecondary};
    transition: color ${transition_slow} ease;
  }

  .accordion-header:hover .accordion-title {
    color: ${base_colorAction};
  }

  .accordion-subtitle {
    margin-top: ${spacing(1)};
  }

  .chevron-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform ${transition_slow} ease;
    transform: rotate(180deg);

    &.expanded {
      transform: rotate(0deg);
    }
  }

  .accordion-content {
    margin-top: ${spacing(3)};
  }
`
